export const articleContents: Record<string, {
  title: string;
  category: string;
  categorySlug: string;
  readTime: string;
  publishedDate: string;
  author: string;
  tags: string[];
  excerpt: string;
  imageQuery: string;
  content: string;
}> = {
  'luolita-lishi-qiyuan': {
    title: '洛丽塔时尚的历史起源：从维多利亚到原宿街头',
    category: '入坑指南',
    categorySlug: 'rukeng-zhinan',
    readTime: '12分钟',
    publishedDate: '2025-06-15',
    author: '樱花酱',
    tags: ['洛丽塔历史', '时尚文化', '原宿风格'],
    excerpt: '追溯洛丽塔时尚的百年历史，从维多利亚时代的儿童服饰到20世纪90年代原宿街头的亚文化浪潮，了解这一独特风格的演变历程。',
    imageQuery: 'Lolita%20fashion%20history%2C%20victorian%20era%20to%20harajuku%20street%2C%20evolution%20timeline%2C%20cream%20background%2C%20editorial%20photography%2C%20warm%20vintage%20lighting',
    content: `<p>洛丽塔时尚（Lolita Fashion）是源自日本的一种独特街头时尚风格，以其华丽精致的裙装、繁复的蕾丝装饰和浓郁的少女气息而闻名于世。然而，要真正理解洛丽塔时尚，我们需要追溯到更早的历史源头。</p>

<h2>维多利亚时代的根源</h2>
<p>洛丽塔时尚的审美根源可以追溯到19世纪维多利亚时代的欧洲。那个时期的女性服饰强调束腰、蓬松的裙摆和大量的蕾丝花边装饰，这些元素后来成为洛丽塔风格的核心美学。维多利亚时代的儿童服饰尤其影响了洛丽塔时尚——当时的儿童穿着与成人款式相似但更为简洁的裙装，这种"成人缩小版"的穿着理念在洛丽塔时尚中得到了延续。</p>
<p>值得注意的是，洛丽塔时尚并非对维多利亚时代的直接复刻，而是吸收了那个时代的浪漫主义精神，将其转化为一种适合当代穿着的时尚表达。蕾丝、蝴蝶结、荷叶边和蓬蓬裙等元素被重新演绎，形成了独特的"新洛丽塔美学"。</p>

<h2>洛可可风格的影响</h2>
<p>除了维多利亚时代，18世纪法国的洛可可风格也对洛丽塔时尚产生了深远影响。洛可可时期崇尚精致、甜美、浪漫的艺术风格，这与洛丽塔时尚追求的氛围高度契合。柔和的粉彩色调、花卉图案、贝壳纹样以及精致的装饰细节，都可以在当代洛丽塔服饰中找到对应的表达。</p>

<h2>日本原宿的亚文化浪潮</h2>
<p>洛丽塔时尚的真正诞生地是20世纪90年代的日本原宿。当时，原宿街头聚集了大量追求个性表达的年轻人，形成了丰富多彩的街头时尚文化。在这样的土壤中，洛丽塔风格应运而生。</p>
<p>早期的洛丽塔品牌如Milk、Pink House等开始推出带有维多利亚风格的少女裙装，很快受到年轻女性的追捧。1990年代末期，BABY, THE STARS SHINE BRIGHT和Angelic Pretty等品牌的创立，标志着洛丽塔时尚正式成为一种独立的时尚流派。</p>
<p>随着《蔷薇少女》《下妻物语》等动漫和电影作品的热播，洛丽塔时尚获得了更广泛的关注。特别是2004年上映的电影《下妻物语》，讲述了两个女孩——一个热爱洛丽塔时尚、一个热爱暴走族文化——之间的友情故事，让洛丽塔文化真正走进大众视野。</p>

<h2>全球化传播</h2>
<p>进入21世纪，洛丽塔时尚迅速从日本走向世界。通过互联网的传播，洛丽塔文化在美国、欧洲、中国等地获得了大量忠实追随者。各地的洛丽塔社区蓬勃发展，国际洛丽塔茶会活动也成为Lo娘们交流的重要平台。</p>
<p>在中国，洛丽塔文化自2010年前后开始快速发展，涌现出大量优秀的国牌洛丽塔品牌，形成了独具特色的中国洛丽塔文化圈。如今，中国的洛丽塔市场规模已经位居全球前列。</p>

<h2>洛丽塔时尚的当代意义</h2>
<p>洛丽塔时尚不仅仅是一种穿着风格，更是一种生活态度和文化表达。对于热爱洛丽塔的女性而言，穿上心爱的洛丽塔裙装是一种自我表达的方式，是对美好事物的追求，也是对日常生活的诗意化表达。在快节奏的现代社会中，洛丽塔时尚为人们提供了一个回归浪漫、享受精致的空间。</p>`,
  },
  'san-dafengge-quan-jiexi': {
    title: '洛丽塔三大风格全解析：甜系·哥特·古典的完美对比',
    category: '穿搭技巧',
    categorySlug: 'chuanda-jiqiao',
    readTime: '15分钟',
    publishedDate: '2025-07-02',
    author: '蔷薇少女',
    tags: ['洛丽塔风格', '甜美系', '哥特系', '古典系'],
    excerpt: '甜美系、哥特系、古典系——洛丽塔三大主流风格的核心差异、代表元素与穿搭场景全面对比，帮你找到最适合自己的风格。',
    imageQuery: 'Three%20Lolita%20styles%20comparison%2C%20sweet%20gothic%20classic%20side%20by%20side%2C%20pink%20black%20burgundy%2C%20cream%20background%2C%20editorial%20photography%2C%20clean%20display',
    content: `<p>洛丽塔时尚拥有多个风格分支，其中甜美系、哥特系和古典系是最具代表性的三大主流风格。每种风格都有其独特的审美取向、配色方案和穿搭场景。本文将带你深入了解这三大风格的核心差异，帮助你找到最适合自己的洛丽塔风格。</p>

<h2>甜美系洛丽塔（Sweet Lolita）</h2>
<p>甜美系洛丽塔是最广为人知的洛丽塔风格分支。它以梦幻可爱的少女形象为核心，强调粉嫩甜美的视觉效果。</p>
<p><strong>配色特点：</strong>以粉色、白色、浅蓝色、淡紫色等柔和色调为主。整体配色明亮温暖，充满童话般的梦幻感。</p>
<p><strong>代表元素：</strong>草莓、樱桃、糖果、兔子、爱心、蝴蝶结、蕾丝花边。印花图案通常以可爱的卡通风格呈现，充满童趣。</p>
<p><strong>裙型特征：</strong>裙摆通常较为蓬松，多采用A字型或钟型裙摆。裙长一般在膝盖附近，搭配多层裙撑打造蓬松效果。</p>
<p><strong>穿搭场景：</strong>茶会聚会、逛街约会、日常出行。甜美系洛丽塔是最适合日常穿着的风格。</p>

<h2>哥特洛丽塔（Gothic Lolita）</h2>
<p>哥特洛丽塔融合了维多利亚哀悼服饰与暗黑浪漫美学，呈现出神秘优雅的暗黑公主气质。</p>
<p><strong>配色特点：</strong>以黑色为主基调，搭配深紫色、酒红色、暗蓝色等深沉色调。偶尔以白色作为对比点缀，但整体保持暗黑调性。</p>
<p><strong>代表元素：</strong>十字架、蝙蝠、玫瑰、蜘蛛网、教堂彩窗图案。装饰以黑色蕾丝、丝绒面料为主，带有浓郁的哥特文化气息。</p>
<p><strong>裙型特征：</strong>裙型与甜美系相似，但面料更倾向丝绒、缎面等华丽质感。裙摆同样蓬松，但整体氛围更为庄重。</p>
<p><strong>穿搭场景：</strong>音乐会、艺术展览、主题派对。哥特洛丽塔更适合追求个性的场合穿着。</p>

<h2>古典系洛丽塔（Classic Lolita）</h2>
<p>古典系洛丽塔是最接近维多利亚原型的风格，注重优雅沉稳的气质而非过度的甜美或暗黑。</p>
<p><strong>配色特点：</strong>以酒红色、墨绿色、藏蓝色、米白色、驼色等成熟色调为主。整体配色沉稳大方，散发知性优雅气息。</p>
<p><strong>代表元素：</strong>宫廷花卉、古典纹样、油画风格印花、珍珠装饰、蕾丝手套。细节更为精致内敛，不过分张扬。</p>
<p><strong>裙型特征：</strong>裙长通常较长，剪裁更为端庄。A字裙型为主，裙摆蓬松度适中，更接近维多利亚时代的淑女裙装。</p>
<p><strong>穿搭场景：</strong>下午茶、音乐会、美术馆参观。古典系洛丽塔是最容易融入日常社交场合的风格。</p>

<h2>如何选择适合自己的风格？</h2>
<p>选择洛丽塔风格时，建议从以下几个方面考虑：</p>
<p><strong>个人气质：</strong>甜美系适合可爱活泼的女孩，哥特系适合个性独立的神秘气质，古典系适合优雅成熟的女性。当然，也可以根据心情和场合灵活切换。</p>
<p><strong>穿着场景：</strong>如果是日常通勤或逛街，古典系和低调的甜美系是不错的选择；参加茶会可以选择华丽的甜美系；而音乐会或主题派对则适合哥特系。</p>
<p><strong>预算考量：</strong>不同风格的入门成本有差异，甜美系品牌选择最多、价格区间最广，古典系和哥特系相对小众但精品品牌众多。</p>`,
  },
  'luolita-pinpai-quangonglve': {
    title: '洛丽塔品牌全攻略：日牌·国牌·欧美品牌大盘点',
    category: '入坑指南',
    categorySlug: 'rukeng-zhinan',
    readTime: '18分钟',
    publishedDate: '2025-07-10',
    author: '洛丽塔研究所',
    tags: ['洛丽塔品牌', '日牌', '国牌', '购物指南'],
    excerpt: '从Angelic Pretty、BABY到国牌新锐，为你全面盘点全球洛丽塔品牌，附购买渠道与价位参考。',
    imageQuery: 'Lolita%20brands%20collection%2C%20Japanese%20Chinese%20western%20brands%2C%20dress%20display%2C%20cream%20background%2C%20editorial%20photography%2C%20clean%20lighting',
    content: `<p>洛丽塔时尚拥有丰富的品牌生态，从日本老牌到中国新锐，从欧美小众到韩国独立设计，每个品牌都有其独特的风格定位和设计哲学。本文为你全面盘点全球主要的洛丽塔品牌。</p>

<h2>日本品牌</h2>
<p><strong>BABY, THE STARS SHINE BRIGHT</strong>：创立于1988年的元老级洛丽塔品牌，以甜美系和古典系著称。其设计精致华丽，印花独具一格，是许多Lo娘心中的殿堂级品牌。代表系列包括"お菓子の国"（糖果王国）和"白雪姫"（白雪公主）等。</p>
<p><strong>Angelic Pretty</strong>：全球最知名的甜美系洛丽塔品牌，以极致甜美的设计风格闻名。色彩鲜艳明快，印花充满童话气息，深受喜爱可爱风格的Lo娘追捧。品牌代言人包括众多知名洛丽塔模特。</p>
<p><strong>Moi-même-Moitié</strong>：由视觉系乐队Malice Mizer的吉他手Mana创立的哥特洛丽塔品牌，是哥特系洛丽塔的殿堂级代表。以黑色为主调，融合优雅与暗黑美学。</p>

<h2>中国品牌</h2>
<p><strong>古典玩偶</strong>：国内最知名的洛丽塔品牌之一，以精致的刺绣工艺和独特的中国风设计著称。擅长将中国传统元素融入洛丽塔美学。</p>
<p><strong>Infanta</strong>：以高性价比著称的国牌，设计风格涵盖甜美、古典等多种风格。是许多新人的入坑首选品牌。</p>
<p><strong>ZJ Story</strong>：以独特的设计故事性和高质量面料闻名，每一季都围绕一个完整的故事主题展开设计。</p>

<h2>欧美品牌</h2>
<p><strong>Lady Sloth</strong>：波兰洛丽塔品牌，以独特的印花设计和友好的大码选择受到国际Lo娘喜爱。</p>
<p><strong>Haenuli</strong>：韩国品牌，以梦幻的插画风格印花和精致的细节设计在国际市场上拥有极高人气。</p>`,
  },
};